export default {
  default: () => import("/builds/RunRepeat/rr_front/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/builds/RunRepeat/rr_front/layouts/empty.vue").then(m => m.default || m)
}